"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pad = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const rn_css_1 = require("rn-css");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const left_1 = require("./button/left");
const right_1 = require("./button/right");
const down_1 = require("./button/down");
const up_1 = require("./button/up");
const ok_1 = require("./button/ok");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const Pad = ({ pressOk, pressUp, pressDown, pressLeft, pressRight, size = 160, backgroundColor, color, borderColor }) => {
    const theme = (0, rn_css_1.useTheme)();
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const currentTheme = theme || base_ui_theme_themes_1.defaultTheme;
    const pad_backgroundColor = backgroundColor || currentTheme.currentPalette.c800;
    const pad_borderColor = borderColor || "rgba(0,0,0,1)";
    const pad_textColor = color || currentTheme.currentPalette.c100;
    const width = normalize(size), height = normalize(size);
    const padWidth = ( /* 214 */200 / 300) * width;
    const padHeight = (121 / 300) * height;
    const sizeCircle = (73 / 300) * normalize(size);
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement("svg", { width: width, height: height },
            react_1.default.createElement(ok_1.ButtonPadOk, { x: (width - sizeCircle) / 2, y: (height - sizeCircle) / 2, width: sizeCircle, height: sizeCircle, color: pad_textColor, backgroundColor: pad_backgroundColor, borderColor: pad_borderColor, onPressIn: pressOk }),
            react_1.default.createElement(left_1.ButtonPadLeft, { x: 0, y: (height - padWidth) / 2, width: padHeight, height: padWidth, color: pad_textColor, backgroundColor: pad_backgroundColor, borderColor: pad_borderColor, onPressIn: pressLeft }),
            react_1.default.createElement(right_1.ButtonPadRight, { x: width - padHeight, y: (height - padWidth) / 2, width: padHeight, height: padWidth, color: pad_textColor, backgroundColor: pad_backgroundColor, borderColor: pad_borderColor, onPressIn: pressRight }),
            react_1.default.createElement(down_1.ButtonPadDown, { x: (width - padWidth) / 2, y: height - padHeight, width: padWidth, height: padHeight, color: pad_textColor, backgroundColor: pad_backgroundColor, borderColor: pad_borderColor, onPressIn: pressDown }),
            react_1.default.createElement(up_1.ButtonPadUp, { x: (width - padWidth) / 2, y: 0, width: padWidth, height: padHeight, color: pad_textColor, backgroundColor: pad_backgroundColor, borderColor: pad_borderColor, onPressIn: pressUp }))));
};
exports.Pad = Pad;
//# sourceMappingURL=pad.js.map